import { render, staticRenderFns } from "./ImageStorage.vue?vue&type=template&id=6d589b1c&"
import script from "./ImageStorage.vue?vue&type=script&lang=js&"
export * from "./ImageStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports